var styles = {"box":"GamePreview_box_fqehe_1","card":"GamePreview_card_fqehe_7","card__media":"GamePreview_card__media_fqehe_17"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
